export default {
  'SAVE_TEXTS' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  },
  'CLEAR_TEXTS' (state) {
    state.items = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/texts/mutations.js